export default __webpack_public_path__ + "static/sixt-36cdd23765f601391e1ed53c7d8e11ba.png";